// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"Modal_modal-scroll__mYw2n","container":"Modal_container__W68OD","dim":"Modal_dim__CYjr0","confirm":"Modal_confirm__xC7tu","content":"Modal_content__XGEHb"};